var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"pa-4",attrs:{"flat":""}},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{staticClass:"text-right",attrs:{"cols":"12"}},[_c('TableMedien',{ref:"table",attrs:{"showTitle":false,"companyId":_vm.companyId,"isCompanyView":true}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }